import { css } from '@emotion/react'

import { breakpoint, size, width } from '@twisto/styles'

export const container = css`
  display: grid;
  padding: clamp(${size[24]}, 9vw - ${size[8]}, ${size[128]}) ${size[24]};

  ${breakpoint.up('md')} {
    grid-template-columns: 306px 1fr;
    column-gap: ${size[24]};
  }
`

export const content = css`
  width: 100%;
  overflow-x: hidden;
`

export const searchInput = css`
  margin-bottom: ${size[24]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[40]};
  }
`

export const breadcrumb = css`
  margin-bottom: ${size[12]};
`

export const dropdown = css`
  ${breakpoint.up('sm')} {
    min-width: max-content;
    max-width: ${width.container.small};
  }
`
